import React from 'react';
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from "react-redux";
import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
// import {Input} from "antd";
import {Type} from "bukku/redux/Transaction/helper";
// import {LockIcon} from "../../Access/common/LockIcon";
import AutoComplete from "../../AutoComplete";
import {useList} from "bukku/redux/List/helper";
import {L} from "bukku/redux/List/reducer";
import {TableName} from "bukku/redux/EditableTable/options";
import {Select} from "../../DataEntry";
import { NumberFormatHelper } from '../../NumberFormat/helpers';
import { LockTooltip } from '../../Access/common/LockTooltip';

export function getTransactionType(tableName) {
    switch (tableName) {
        case TableName.batch_invoice:
        case TableName.batch_invoice_cash:
            return Type.sale_invoice;
        case TableName.batch_sale_order:
            return Type.sale_order;
        case TableName.batch_delivery_order:
            return Type.sale_delivery_order;
        case TableName.batch_invoice_credit_note:
            return Type.sale_credit_note;
        case TableName.batch_quotation:
            return Type.sale_quote;
        case TableName.batch_invoice_payment:
            return Type.sale_payment;
        case TableName.batch_sale_refund:
            return Type.sale_refund;
        case TableName.batch_purchase_order:
            return Type.purchase_order;
        case TableName.batch_bill:
        case TableName.batch_bill_cash:
        case TableName.batch_bill_expense_claim:
            return Type.purchase_bill;
        case TableName.batch_purchase_credit_note:
            return Type.purchase_credit_note;
        case TableName.batch_bill_payment:
            return Type.purchase_payment;
        case TableName.batch_bank_income:
            return Type.bank_income;
        case TableName.batch_bank_expense:
            return Type.bank_expense;
        case TableName.batch_journal_entry:
            return Type.journal_entry;
        default:
            throw new Error("Unknown TableName");
    }
}

export function getFilterType(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
        case Type.sale_invoice:
        case Type.sale_order:
        case Type.sale_credit_note:
        case Type.purchase_order:
        case Type.purchase_bill:
        case Type.purchase_credit_note:
        case Type.journal_entry:
        case Type.stock_adjustment:
        case Type.stock_transfer:
            return transactionType;
        case Type.sale_payment:
        case Type.purchase_refund:
        case Type.bank_income:
            return Type.official_receipt;
        case Type.sale_refund:
        case Type.purchase_payment:
        case Type.bank_expense:
            return Type.payment_voucher;
        default:
            return transactionType;
    }
}

function InlineNumberSelect(props) {
    const { numberFormats, settings, value, allowClear, onChange, transactionType, inputRef } = props;

    useList(
        [L.number_formats],
        state => state.List.numberFormats.length === 0,
    );
    const hasSubscription = React.useMemo(() => SubscriptionCheck
        .withKeys(SubscriptionScopeKey.MULTI_NUMBER_FORMAT)
        .hasSubscriptionTo(), []);

    const customNumberFormatMode = settings.custom_transaction_number_on;
    const multiNumberFormatLocked = !hasSubscription;

    const commonProps = {
        value,
        placeholder: "No.",
    };

    function getOptions() {
        const filterType = getFilterType(transactionType);
        const filteredNumberFormats = numberFormats.filter(item => item.type === filterType);
        const defaultNumberFormat = filteredNumberFormats
            .find(item => item.id === NumberFormatHelper.getDefaultNumberFormatId(transactionType));

        // console.log('zz filteredNumberFormats', filteredNumberFormats);

        return filteredNumberFormats.map(item => {
            const isDefault = item.id === defaultNumberFormat.id;
            const isLocked = !isDefault && multiNumberFormatLocked;

            const label = isLocked ? (
                <span>
                    {/* {item.format}
                    &nbsp;
                    <LockIcon /> */}
                    <LockTooltip withIcon>{item.format}</LockTooltip>
                </span>) : item.format;

            return {
                value: item.format,
                label,
                disabled: isLocked,
            };
        });
    }

    // Only works for New
    function renderInput() {
        if (customNumberFormatMode) {
            return <AutoComplete
                placeholder={t`Select or Type...`}
                filterOption={false}
                options={getOptions()}
                inputRef={inputRef}
                allowClear={allowClear}
                onChange={value => onChange(value)}
                {...commonProps}
            />;
        }

        return (
            <Select
                options={getOptions()}
                showSearch
                allowClear={allowClear}
                optionFilterProp="label"
                placeholder={t`Select...`}
                ref={inputRef}
                onChange={value => onChange(value)}
                {...commonProps}
            />
        );

        // if (multiNumberFormatLocked && customNumberFormatMode) {
        //     return <Input
        //         placeholder={t`Type...`}
        //         ref={inputRef}
        //         {...commonProps}
        //         onBlur={e => onChange(e.target.value)}
        //     />;
        // }
        // if (!customNumberFormatMode) {
        //     return (
        //         <Select
        //             options={getOptions()}
        //             showSearch
        //             allowClear={allowClear}
        //             optionFilterProp="label"
        //             disabled={multiNumberFormatLocked}
        //             placeholder={t`Select...`}
        //             ref={inputRef}
        //             onChange={value => onChange(value)}
        //             {...commonProps}
        //         />
        //     );
        // }

        // return <AutoComplete
        //     placeholder={t`Select or Type...`}
        //     filterOption={false}
        //     options={getOptions()}
        //     inputRef={inputRef}
        //     allowClear={allowClear}
        //     onChange={value => onChange(value)}
        //     {...commonProps}
        // />;

        // With Custom Number enabled
        // if (customNumberFormatMode) {
        //     // If Multi-number is locked
        //     if (multiNumberFormatLocked) {
        //         return <Input
        //             placeholder={t`Type...`}
        //             ref={inputRef}
        //             {...commonProps}
        //             onBlur={e => onChange(e.target.value)}
        //         />;
        //     }

        //     // If not locked => Custom Number + Multi-Number
        //     return (
        //         <AutoComplete
        //             placeholder={t`Select or Type...`}
        //             filterOption={false}
        //             options={getOptions()}
        //             inputRef={inputRef}
        //             allowClear={allowClear}
        //             onChange={value => onChange(value)}
        //             {...commonProps}
        //         />
        //     );
        // }
        // // With Custom Number disabled
        // return (
        //     <Select
        //         options={getOptions()}
        //         showSearch
        //         allowClear={allowClear}
        //         optionFilterProp="label"
        //         disabled={multiNumberFormatLocked}
        //         placeholder={t`Select...`}
        //         ref={inputRef}
        //         onChange={value => onChange(value)}
        //         {...commonProps}
        //     />
        // );
    }

    return renderInput();
}

InlineNumberSelect.defaultProps = {
    label: '',
    allowClear: true,
};

export default connect(state => ({
    numberFormats: state.List.numberFormats,
    settings: state.List.settings,
    readListsState: state.List.readListsState,
}), {
    //
})(withI18n()(InlineNumberSelect));
